import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class QuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loadingData: true
    };

    this.insertQuestion = this.insertQuestion.bind(this);
  }

  insertQuestion() {
    this.props.history.push("/question/create");
  }

  sendList = () => {};

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const user = this.props.user.user.id;

    axios
      .post(
        `${URL.api}evaluation/question/list`,
        { user },
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({
              list: resp.data.data.map(question => ({
                ...question,
                question: JSON.parse(question.description)[0]?.children[0]?.text
              })),
              loadingData: false
            });
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  render() {
    return (
      <div id="list" className="animated fadeIn">
        {this.state.loadingData ? (
          <Loading />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <DataTable
                list={this.state.list}
                path="/question/create/"
                title="Tabela de Questões"
                header={[
                  { name: "id", denomination: "ID" },
                  { name: "question", denomination: "Questão" },
                  { name: "author", denomination: "Autor" },
                  { name: "type_name", denomination: "Tipo" },
                  { name: "private", denomination: "Privado" }
                ]}
                csv
                insert
                delete
                insertAction={this.insertQuestion}
                action
                btnEdit
                btnDelete={false}
                btnPrint={false}
                btnAllocate={false}
                btnReport
              />
            ) : (
              "Carregando..."
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionList);
